export default "__VITE_ASSET__C9XNV6K5__"